function WebSocketClient(url) {
  var stompClient = webstomp.over(new SockJS(url));

  var wrappedSocket = {
    connect: function() {
      return new Promise(function(resolve, reject) {
        if (!stompClient) {
          reject("STOMP client not created");
        } else {
          stompClient.connect({}, function(frame) {
            resolve(frame);
          }, function(error) {
            console.log(error);
            reject("STOMP protocol error " + error);
          });
        }
      });
    },
    disconnect: function() {
      stompClient.disconnect();
    },
    subscribe: function(destination, successFunction) {
      stompClient.subscribe(destination, function(message) {
        successFunction(JSON.parse(message.body));
      });
    },
    send: function(destination, object, headers) {
      stompClient.send(destination, object, headers);
    },
    isDisconnected: function() {
      return stompClient.readyState() == WebSocket.CLOSING || stompClient.readyState() == WebSocket.CLOSED;
    }
  };

  return wrappedSocket;
}